<template>
  <div class="chat-container w-100 position-relative bg-white">
    <!-- NAVBAR -->
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-green">
                  <div class="px-4 w-100 pt-1">
                    <div class="w-100">
                      <div class="row no-gutters py-3 m-0">
                        <div class="col-1 align-self-center">
                          <router-link :to="`/${getMerchant.code}/concierge/room-dining`" class="d-inline-grid">
                            <img src="../../../../assets/img/icon/back-white.svg" class="mt-1" width="18">
                          </router-link>
                        </div>
                        <div class="col-10 align-self-center">
                          <p class="mb-0 body-1-2 text-truncate text-white">{{$t('hotel.concierge.fitur.checkout')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="height-63px mb-3"></div>

    <div v-if="is_load" class="w-100 py-5 text-center">
      <loader />
    </div>
    <template v-else>
      <ErrorMessage v-if="error != ''" :message="error" />
      <template v-else>
        <!-- ROOM -->
        <div class="mt-4 pb-4 border-b-semi-grey px-4" v-if="reservation.room && Object.keys(reservation.room).length > 0">
          <div class="w-100 p-3 bg-border-green-light radius-12">
            <p class="mb-0 body-2-1">{{$t('hotel.room')}} : {{reservation.room.name}}</p>
            <!-- <p class="mb-0 body-3-3-1">{{$t('hotel.concierge.fitur.cart.qr-desc')}}</p> -->
            <p class="mb-0 body-3-3-1">You will transact through the room</p>
          </div>
        </div>

        <!-- REWARD -->
        <ClaimingReward wrapper_class="px-4 border-b-semi-grey pb-4 mb-4"></ClaimingReward>
        
        <!-- PRODUCT LIST -->
        <div class="my-4 border-b-semi-grey pb-4">
          <div class="px-4 border-b-semi-grey pb-4 mb-4">
            <div class="w-100" v-for="product_cart_item in product_cart">
              <roomDiningMenuCart :data="product_cart_item"></roomDiningMenuCart>
            </div>
          </div>
          <div class="px-4">
            <div class="w-100">
              <div class="row no-gutters">
                <div class="col-9 align-self-center">
                  <p class="body-1-2 mb-0">{{$t('hotel.concierge.fitur.cart.more-title')}}</p>
                  <p class="body-2-2-1 mb-0">{{$t('hotel.concierge.fitur.cart.more-desc')}}</p>
                </div>
                <div class="col-3 align-self-center">
                  <button class="ga-btn-primary-outline-md" @click="goToHome()">
                    {{$t('hotel.action.add')}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- NOTES -->
        <div class="mb-4 pb-4 border-b-semi-grey px-4">
          <p class="mb-0 body-1-4">{{$t('restaurant.note')}}</p>
          <p class="mb-2 body-2-2-1">{{$t('hotel.concierge.fitur.cart.note-desc')}}</p>
          <div class="w-100 position-relative">
            <textarea
              rows="1"
              class="body-2-2 pl-5 pr-3 w-100 border-semi-grey radius-12" 
              style="padding-top:12px;padding-bottom:12px;"
              v-model="notes">
            </textarea>
            <img src="../../../../assets/img/icon/notes.svg" height="14" class="position-absolute" style="left:20px;top:15px;">
          </div>
        </div>

        <!-- PROMO CODE -->
        <div id="promo_section">
          <cartPromoCode type="room-dining"></cartPromoCode>
        </div>

        <!-- CUSTOMER FORM -->
        <div class="mb-4 pb-4 border-b-semi-grey px-4">
          <p class="mb-0 body-1-4">{{$t('hotel.menu.personal-data')}}</p>
          <p class="mb-2 body-2-2-1">{{$t('hotel.concierge.fitur.cart.personal-data-desc')}}</p>
          <div class="w-100 mb-3">
            <label for="form_name" class="body-3-1 mb-1 w-100">{{$t('general.your-name')}} <span class="font-weight-bold text-danger">*</span></label>
            <input 
              id="form_name" 
              type="text" 
              class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
              :class="{'border-danger':form_validation.name != ''}"
              style="padding: 12px 14px;"
              v-model="customer_detail.first_name" />
              <p v-if="form_validation.name != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.name}}</p>
          </div>
          <div class="w-100 mb-3">
            <label for="form_email" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.fitur.cart.email-address')}} <span class="font-weight-bold text-danger">*</span></label>
            <input 
              id="form_email" 
              type="text" 
              class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
              :class="{'border-danger':form_validation.email != ''}"
              style="padding: 12px 14px;"
              v-model="customer_detail.email" />
              <p v-if="form_validation.email != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.email}}</p>
          </div>
          <div class="w-100">
            <label for="form_phone" class="body-3-1 mb-1 w-100">{{$t('hotel.concierge.form.phone-number')}} <span class="ml-1 text-semi-light">({{$t('hotel.concierge.fitur.cart.optional')}})</span></label>
            <input 
              id="form_phone" 
              type="text" 
              class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
              style="padding: 12px 14px;"
              v-model="customer_detail.phone_number" />
          </div>
          <div class="w-100">
            <label for="form_room" class="body-3-1 mb-1 w-100">Room <span class="font-weight-bold text-danger">*</span></label>
            <input 
              :disabled="reservation.room && reservation.room.id"
              id="form_room" 
              type="text" 
              class="border-semi-grey radius-12 body-2-1 w-100 mb-1"
              :class="{'border-danger':form_validation.room != ''}"
              style="padding: 12px 14px;"
              v-model="customer_detail.room" />
            <p v-if="form_validation.room != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{form_validation.room}}</p>
          </div>
        </div>

        <!-- PAYMENT METHODS -->
        <div class="mb-4 pb-4 border-b-semi-grey px-4">
          <p class="mb-0 body-1-4">{{$t('general.payment-method')}}</p>
          <p class="mb-2 body-2-2-1">{{$t('hotel.concierge.fitur.cart.payment-method-desc')}}</p>
          <div class="w-100 p-3 bg-border-green-light radius-12">
            <p class="mb-0 body-2-1">{{$t('hotel.concierge.fitur.cart.payment-method-cash-title')}}</p>
            <p class="mb-0 body-3-3-1">{{$t('hotel.concierge.fitur.cart.payment-method-cash-desc')}}</p>
          </div>
        </div>

        <!-- PRICE -->
        <div class="pb-4 border-b-semi-grey px-4">
          <div class="w-100 border-semi-grey radius-12">
            <div class="p-3 border-b-semi-grey-dashed">
              <p class="mb-3 body-1-2">{{$t('hotel.concierge.price-detail')}}</p>
              <div class="row mb-2">
                <div class="col-6">
                  <p class="body-2-1 mb-0">{{$t('hotel.concierge.sub-total')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-1 mb-0">{{$formatCurrency(getConciergeOrderSubTotal)}}</p>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-6">
                  <p class="body-2-1 mb-0 text-green">{{$t('hotel.concierge.discount')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-2-1 mb-0">- {{$formatCurrency(getConciergeOrderTotalPromo)}}</p>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <p class="body-2-1 mb-0">{{$t('hotel.concierge.tax-service')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="body-2-1 mb-0">{{$formatCurrency(getConciergeOrderTotalTaxServices)}}</p>
                </div>
              </div>
            </div>
            <div class="p-3">
              <div class="row">
                <div class="col-6">
                  <p class="body-1-2 mb-0">{{$t('hotel.concierge.total')}}</p>
                </div>
                <div class="col-6 text-right">
                  <p class="sub-heading-1-2 mb-0">{{$formatCurrency(total_price)}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- BUTTON -->
        <div class="height-63px mb-3"></div>
        <div class="position-relative z-index-1028">
          <div class="row no-gutters justify-content-center">
            <div class="fixed-bottom d-block">
              <div class="custom-container-fluid px-0">
                <div class="row justify-content-center no-gutters">
                  <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                    <div class="w-100 bg-white">
                      <div class="px-4 py-3">
                        <p v-if="error_push != ''" class="mb-2 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{error_push}}</p>
                        <state-button variant="primary" :click="submitInquiry" block size="lg">
                          {{$t('restaurant.empty-cart.button')}}
                        </state-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {get,post} from '@/services/index.js';
  import roomDiningMenuCart from '@/components/hotel/concierge/general/roomDiningMenuCart'
  import cartPromoCode from '@/components/hotel/concierge/general/cartPromoCode'
  import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
  import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");

  export default{
    components:{
      roomDiningMenuCart,
      cartPromoCode,
      ClaimingReward
    },
    data(){
      return{
        is_load: true,
        error: '',
        general_data: '',
        notes: '',
        customer_detail:{
          first_name: '',
          email: '',
          phone_number: '',
          room: ''
        },
        form_validation:{
          name: '',
          email: '',
          room: ''
        },
        push_loader: false,
        error_push: '',
        reservation: {}
      }
    },
    mixins: [validationMixin],
    validations: {
      customer_detail:{
        first_name:{
          required
        },
        email:{
          required,
          email
        },
        room:{
          required
        },
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getMetaTitleTemplate',
        'getConciergeOrder',
        'getConciergeOrderSubTotal',
        'getConciergeOrderTotalTaxServices',
        'getConciergeOrderTotalPromo',
        'getUpsellRef',
        'isLoggedIn',
        'getCurrentUser',
        'isReservationActive',
        'getReservationActive',
        'getMembershipRewardApplied',
        'isMembershipRewardApplied',
        'getConciergeReservation']),
      product_cart(){
        return this.getConciergeOrder.cart
      },
      total_price(){
        return this.getConciergeOrderSubTotal+this.getConciergeOrderTotalTaxServices-this.getConciergeOrderTotalPromo
      },
    },
    created(){
      this.$validateActiveReward('concierge-room-dining')
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      ...mapMutations(['resetConciergeOrder','setConciergeReservationPerKey','setReservationActive']),
      goToHome(){
        this.$router.push(`/${this.getMerchant.code}/concierge/room-dining`)
      },
      scrollTo(id){
        document.getElementById(id).scrollIntoView({
          behavior: 'smooth'
        });
      },
      fillCustomerData(with_rsv=true){
        if(with_rsv){
          this.customer_detail = {
            first_name: this.reservation.guest_profile.name,
            email: this.reservation.guest_profile.email,
            phone_number: this.reservation.guest_profile.phone
          }
          if(this.reservation.room.id){
            this.customer_detail.room = this.reservation.room.name
          }
        }else{
          let name = this.$isNotEmpty(this.getCurrentUser.last_name) ? `${this.getCurrentUser.first_name} ${this.getCurrentUser.last_name}` : this.getCurrentUser.first_name
          this.customer_detail = {
            first_name: name,
            email: this.getCurrentUser.email,
            phone_number: this.getCurrentUser.phone
          }
        }
      },
      validateForm(){
        this.form_validation = {
          name: false,
          email: false,
          room: false
        }
        if(this.$v.customer_detail.first_name.$invalid){
          this.form_validation.name = this.$t('hotel.concierge.fitur.validation.please-input-your-name')
          this.scrollTo('promo_section')
        }
        if(this.$v.customer_detail.email.$invalid){
          if(!this.$v.customer_detail.email.required){
            this.form_validation.email = this.$t('hotel.concierge.fitur.validation.please-input-your-email-address')
          }else if(!this.$v.customer_detail.email.email){
            this.form_validation.email = this.$t('hotel.concierge.fitur.validation.incorrect-email')
          }else{
            this.form_validation.email = ''
          }
          this.scrollTo('promo_section')
        }
        if(this.$v.customer_detail.room.$invalid){
          this.form_validation.room = 'Please input your room name'
          this.scrollTo('promo_section')
        }
        if(!this.$v.customer_detail.first_name.$invalid && !this.$v.customer_detail.email.$invalid && !this.$v.customer_detail.room.$invalid){
          return true
        }else{
          return false
        }
      },
      loadFirstData(){
        this.is_load = true
        this.error = ''
        let func_exc = [this.loadGeneralSetting()]
        if(this.isReservationActive){
          func_exc.push(this.loadDetailReservation())
        }
        Promise.all(func_exc)
          .then(()=>{
            if(!this.isReservationActive && this.isLoggedIn){
              this.fillCustomerData(false)
            }
            if(this.$isNotEmptyV3(this.getConciergeReservation.room)){
              this.customer_detail.room = this.getConciergeReservation.room.name
            }
          })
          .catch(err=>this.error = err)
          .finally(()=>this.is_load = false)
      },
      loadGeneralSetting(){
        return new Promise((success,fail)=>{
          this.general_data = {}  
          get("CONCIERGE","room-dining/general",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.general_data = res.data
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadDetailReservation(){
				return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${this.getReservationActive.detail_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
						let res = response.data
            if(res.success){
							let resv = res.data
							if(this.$isReservationValid(resv)){
								this.reservation = resv
                this.fillCustomerData()
							} else{
								this.setReservationActive('reset')
							}
              success()
            }else{
              fail(res.message)
            }
          })
        })
			},
      submitInquiry(){
        return new Promise((success,fail)=>{
          this.error_push = ''
          if(this.validateForm()){
            let getRoomId = () => {
              return this.isReservationActive && Object.keys(this.reservation.room).length > 0 ? this.reservation.room.id : ''
            }
            
            let params = {
              merchant_id: this.getMerchant.id,
              products:[],
              customer_detail: this.customer_detail,
              room_id: getRoomId(),
              room_name: this.customer_detail.room,
              merchant_pos_id: this.general_data.merchant_pos_id,
              notes: this.notes,
              region: '',
              device: this.$getDeviceType(),
              promo_code: this.getConciergeOrder.promo_code,
              campaign_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'CAMPAIGN' ? this.getUpsellRef.id : '',
              guest_journey_id: this.getUpsellRef.id != '' && this.getUpsellRef.type == 'GUEST_JOURNEY' ? this.getUpsellRef.id : '',
              reservation_id: this.reservation.id ? this.reservation.id : ''  
            }
  
            if(this.isMembershipRewardApplied){
              params.membership_reward_id = this.getMembershipRewardApplied.id
            }
  
            for(let cart of this.getConciergeOrder.cart){
              if(cart.product.is_variant){
                for(let variant of cart.variant){
                  let product = {
                    id: cart.product.variant_type == 'basic' ? variant.data.product_ga_pos_id : cart.product.data.product_ga_pos_id,
                    qty: variant.qty,
                    notes: cart.product.variant_type == 'basic' ? variant.notes : `${variant.data};${variant.notes}`
                  }
                  params.products.push(product)
                }
              }else{
                let product = {
                  id: cart.product.data.product_ga_pos_id,
                  qty: cart.qty,
                  notes: cart.notes
                }
                params.products.push(product)
              }
            }
  
            post("CORE_HOTEL","merchant-pos/tx-inquiry",params).then(response=>{
              let res = response.data
              if(res.success){
                this.resetConciergeOrder('with_reward')
                this.$router.push(`/${this.getMerchant.code}/concierge/trx-result/${res.data.id}`)
              }else{
                this.error_push = res.message
              }
              success()
            })
  
          }else{
            fail()
          }
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/roomdining/RoomDiningCart.vue